// Caminhos do legado (router.tsx:1532-1575): a recuperação e as rotas irmãs de acordos.
export const COLLECTION_PATH = '/gestao-carteira/recuperacao';
export const QUEUE_PATH = `${COLLECTION_PATH}/fila`;
export const DEBTOR_PATH = `${COLLECTION_PATH}/devedor`;
/** Lista e detalhe do acordo (parte 2): rotas irmãs da recuperação, como no legado (router.tsx:1559-1575). */
export const AGREEMENTS_PATH = `${COLLECTION_PATH}/acordos`;

export const debtorPath = (installmentId: string) => `${DEBTOR_PATH}/${installmentId}`;
export const agreementPath = (agreementId: string) => `${AGREEMENTS_PATH}/${agreementId}`;
